module.exports = {
      id: "food-stylist-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#food-stylist",
      toString: function () {
        return this.url;
      }
    }